import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user/user.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { AuthGuard } from './auth/auth.guard';
import { LandComponent } from './land/land.component';
import { PaymentComponent } from './payment/payment.component';
import { PwdChangeComponent } from './user/pwd-change/pwd-change.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ForgotpwdComponent } from './user/forgotpwd/forgotpwd.component';
import { ResetPwdComponent } from './user/reset-pwd/reset-pwd.component';
import { RaiseTicketComponent } from './raise-ticket/raise-ticket.component';
import { AssignExpertComponent } from './moderator/assign-expert/assign-expert.component';
import { GetAssignedTicketsComponent } from './expert/get-assigned-tickets/get-assigned-tickets.component';
import { GetTicketsComponent } from './customer/get-tickets/get-tickets.component';
import { HomeComponent } from './home/home.component';
import { AlloyComponent } from './alloy/alloy.component';
import { GetAlloysComponent } from './customer/get-alloys/get-alloys.component';
import { EditAlloysComponent } from './customer/edit-alloys/edit-alloys.component';
import { ForgotusernameComponent } from './user/forgotusername/forgotusername.component'
import { UpdateProfileComponent } from './user-profile/update-profile/update-profile.component';
import { EnterBankingDetailsComponent } from './customer/enter-banking-details/enter-banking-details.component';
import { GetAllUnapprovedCustomersComponent } from './moderator/get-all-unapproved-customers/get-all-unapproved-customers/get-all-unapproved-customers.component';
import { CheckCustomerComponent } from './moderator/check-customer/check-customer/check-customer.component';
import { ReplyToTicketComponent } from './expert/reply-to-ticket/reply-to-ticket.component';
import { CurveAnalyzerComponent } from './shared/curve-analyzer/curve-analyzer.component';
import { ViewLatestGraphComponent } from './customer/view-latest-graph/view-latest-graph.component';
import { ViewAllGraphsComponent } from './customer/view-all-graphs/view-all-graphs.component';
import { GetCustomersAddCreditComponent } from './moderator/get-customers-add-credit/get-customers-add-credit.component';
import { GetTransactionsComponent } from './customer/get-transactions/get-transactions.component';
import { StandardAlloysComponent } from './customer/standard-alloys/standard-alloys.component';
import { VerifyConversationComponent } from './moderator/verify-conversation/verify-conversation.component';
import { ChangePasswordFirstloginComponent } from './user/change-password-firstlogin/change-password-firstlogin.component';
import { ScatterPlotComponent } from './shared/scatter-plot/scatter-plot.component';
import { ViewAllTransactionsComponent } from './shared/view-all-transactions/view-all-transactions.component';
import { CreateUserComponent } from './moderator/create-user/create-user.component';
import { ManageProfilesComponent } from './moderator/manage-profiles/manage-profiles.component';
import { InvoiceComponent } from './moderator/invoice/invoice.component';
import { ViewTransactionsComponent } from './expert/view-transactions/view-transactions.component';
import { TermsAndConditionsComponent } from './user/terms-and-conditions/terms-and-conditions.component';
import { ReportComponent } from './moderator/report/report.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { TandCLoggedIn } from './customer/TandC-logged-in/TandC-logged-in.component';

const routes: Routes = [
  {
    path: 'signin', component: UserComponent,
    children: [
      {
        path: '',
        component: SignInComponent}]
  },
  {
    path: 'userprofile', component: UserProfileComponent,canActivate:[AuthGuard]
  },
  {
    path: 'updateprofile', component: UpdateProfileComponent, canActivate:[AuthGuard]
  },
  {
    path: 'AcceptedT&C', component: TandCLoggedIn
  },
  {
    path: 'about', component: AboutComponent
  },
  {
    path: 'contact', component: ContactComponent
  },
  {
    path: 'home', component: HomeComponent
  },
  {
    path: 'acceptpolicy', component: TermsAndConditionsComponent
  },
  {
    path: 'changepwd', component: PwdChangeComponent, canActivate:[AuthGuard]
  },
  {
    path: 'subscribe', component: SubscriptionComponent
  },
  {
    path: 'forgotpwd', component: ForgotpwdComponent
  },
  {
    path: 'forgotusername', component: ForgotusernameComponent
  },
  {
    path: 'resetpwd', component: ResetPwdComponent
  },
  {
    path: 'raise-ticket', component: RaiseTicketComponent
  },
  {
    path: 'get-all-tickets', component: GetTicketsComponent
  },
  {
    path: 'get-assigned-tickets', component: GetAssignedTicketsComponent
  },
  {
    path: 'assign-expert', component: AssignExpertComponent
  },
  {
    path: 'alloy', component: AlloyComponent
  },
  {
    path: 'get-all-alloys', component: GetAlloysComponent
  },
  {
    path: 'get-standard-alloys', component: StandardAlloysComponent
  },
  {
    path: 'edit-alloys', component: EditAlloysComponent
  },
  {
    path: 'enter-banking-details', component: EnterBankingDetailsComponent
  },
  {
    path: 'get-un-customers', component: GetAllUnapprovedCustomersComponent
  },
  {
    path: 'check-customer', component: CheckCustomerComponent
  },
  {
    path: 'reply-to-ticket', component: ReplyToTicketComponent
  },
  {
    path:'view-latest-graph', component: ViewLatestGraphComponent
  },
  {
    path:'view-all-graphs', component: ViewAllGraphsComponent
  },
  {
    path:'analyze-curve', component: CurveAnalyzerComponent
  },
  {
    path:'payment', component: PaymentComponent
  },
  {
    path:'add-credit', component:GetCustomersAddCreditComponent
  },
  {
    path:'get-transactions', component: GetTransactionsComponent
  },
  {
    path:'get-all-transactions', component: ViewAllTransactionsComponent
  },
  {
    path:'view-scattered-plot', component: ScatterPlotComponent
  },
  {
    path:'create-user', component: CreateUserComponent
  },
  {
    path:'verify-conversation', component: VerifyConversationComponent
  },
  {
    path:'change-password-first-login', component: ChangePasswordFirstloginComponent
  },
  {
    path:'manage-profiles', component: ManageProfilesComponent
  },
  {
    path:'invoice', component: InvoiceComponent
  },
  {
    path:'view-transactions', component: ViewTransactionsComponent
  },
  {
    path:'report', component: ReportComponent
  },
  {
    path: '', redirectTo: '/signin', pathMatch: 'full'
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
